import React, {Fragment} from 'react';
import {Col, Container, Row, Button} from 'reactstrap';

import {usePhaseState} from 'funnel-schedule/phase-context';

import PageMeta from 'components/PageMeta';
import SectionCL from 'components/ComponentLibrary/SectionCL';
import {ListIcon} from 'components/Elements/IconList';
import Footer from 'components/Elements/Footer';
import Header from 'components/Elements/Header';

//@ts-ignore
import {graduateCallAdvisors, graduateAdvisors} from 'data/pbcc-content.json';

export default function GraduateCallsIndex() {
  const {
    phases: {
      default: defaultSchedule = {
        phase: 'before'
      }
    }
  } = usePhaseState();

  const clarityCall = defaultSchedule.clarityCall;

  const pageTitle = 'Graduate Calls';
  const pageDescription =
    'Combine in-depth plant-based nutrition education, results-driven coaching skills, and practical training to help you create greater impact and income while making a meaningful difference in the world.';
  const ogImage =
    'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/pbcc/og/pbcc-2026-open-graph-sales-fb-tw.png';
  const shareUrl = 'https://certificate.foodrevolution.org/join/';
  const facebookDescription =
    'Join Food Revolution Network’s Plant-Based Coaching Certificate Program to empower others with evidence-based nutrition and coaching skills.';
  const twitterDescription =
    'Join Food Revolution Network’s Plant-Based Coaching Certificate Program to empower others with evidence-based nutrition and coaching skills.';
  const twitterImg =
    'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/pbcc/og/pbcc-2026-open-graph-sales-fb-tw.png';
  const pinterestDescription =
    'Join Food Revolution Network’s Plant-Based Coaching Certificate Program to empower others with evidence-based nutrition and coaching skills.';
  const pinterestImg =
    'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/pbcc/og/pbcc-2026-open-graph-sales-pin.png';

  return (
    <div className="page d-flex flex-column page-nosocial">
      <PageMeta title={pageTitle} description={pageDescription} url={shareUrl} ogImage={ogImage} />
      <div className="page-content">
        <Header
          bgColor="black"
          lockupWhite
          logoUrlOverride="https://cdn.foodrevolution.org/pbcc/pbcc-certificate-logo-white.svg"
          logoAltOverride="plant-based coaching logo"
          logoWidthOverride={300}
          logoHeightOverride={59}
          shareUrl={shareUrl}
          shareImg={ogImage}
          facebookDescription={facebookDescription}
          twitterDescription={twitterDescription}
          pinterestDescription={pinterestDescription}
          pinterestImage={pinterestImg}
        />

        <SectionCL id="pbcc-clarity-header" color="white" className="text-center" angle="none" order="first">
          <Container>
            <Row>
              <Col>
                <div className="background-light-gray rounded box-shadow-black-50 p-4 p-lg-5">
                  <h1 className="section-heading text-h2 mb-3">
                    Book Your Free Call with a Plant-Based Coaching Certificate Graduate
                  </h1>
                  <h4 className="mt-0">
                    The Plant-Based Coaching Certificate is a launch <br className="d-none d-xl-block" />
                    pad to bring the food revolution to the world!
                  </h4>
                  <div className="d-flex justify-content-center text-left">
                    <ListIcon className="m-0">
                      <>Reinvent, Revitalize, or Complement Your Career</>
                      <>Gain Deep Knowledge of Plant-Based Nutrition</>
                      <>Learn How To Help People Implement Lasting Changes</>
                      <>Do Meaningful Work That Helps People & The Planet</>
                      <>Work From Anywhere In The World</>
                      <>Create Your Own Personal Health Transformation</>
                      <>Join the Growing Movement of Leaders in the Food Revolution</>
                    </ListIcon>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </SectionCL>

        <SectionCL id="pbcc-clarity-book" color="purple" order="last" angle="top" innerClass="pt-5">
          <Container>
            <Row>
              <Col>
                <div className="text-center text-white">
                  <h3 className="section-heading mb-3">Is becoming a Plant-Based Coach right for you?</h3>
                  <h3 className="mt-0 mb-5">
                    Have questions about FRN’s Plant-Based <br className="d-none d-xl-block" />
                    Coaching Certificate program?
                  </h3>
                  <h5 className="mt-0">Speak to one of our graduates:</h5>

                  <p className="mb-4">
                    <i>
                      <b>If you have already enrolled,</b> please email us at{' '}
                      <a className="link-white text-underline" href="mailto:certificate@foodrevolution.org">
                        certificate@foodrevolution.org
                      </a>{' '}
                      <br className="d-none d-xl-block" />
                      to speak with your Coach Mentor, Makini Duewa, NBC-HWC
                    </i>
                  </p>
                </div>
                <Row className="d-flex align-items-stretch justify-content-center">
                  {graduateCallAdvisors.map((advisor, i) => {
                    return (
                      <Fragment key={advisor + i}>
                        {graduateAdvisors
                          .filter((speaker) => speaker.id === advisor.id)
                          .map((speaker) => {
                            return (
                              <Col key={speaker.id} md="6" lg="4" className="d-flex flex-column flex-grow-1 mb-4">
                                <div className="background-white rounded box-shadow-black-50 d-flex flex-column text-center flex-grow-1">
                                  <div
                                    className="clarity-call-image"
                                    style={{backgroundImage: `url('${speaker.image}')`}}
                                  />
                                  <div className="clarity-call-detail p-3 flex-grow-1 d-flex flex-column">
                                    <h5 className="section-heading mb-1">{speaker.name}</h5>
                                    {speaker.tagline && <p className="mb-0">{speaker.tagline}</p>}
                                    <p className="text-left text-16 mt-3 mb-4">{speaker.bio}</p>
                                    <p className="text-center mt-auto mb-0">
                                      <Button
                                        className="text-16 text-uppercase mt-4"
                                        color="cta"
                                        href={speaker.clarityCallLink.url}
                                        target="_blank"
                                        block
                                        disabled={speaker.clarityCallLink.disabled}
                                      >
                                        {speaker.clarityCallLink.disabled ? (
                                          <>Coming Soon</>
                                        ) : (
                                          <>
                                            Book My Clarity Call <br className="d-none d-xl-block" />
                                            with {speaker.shortName}
                                          </>
                                        )}
                                      </Button>
                                    </p>
                                  </div>
                                </div>
                              </Col>
                            );
                          })}
                      </Fragment>
                    );
                  })}
                </Row>
                <p className="text-center text-white mt-5">The program begins on January 26, 2026.</p>
              </Col>
            </Row>
          </Container>
        </SectionCL>
      </div>
      <div className="footer-content mt-auto">
        <Footer />
      </div>
    </div>
  );
}
